import { INJECTED_FACTORY } from '../constants/type-stamps.const';
/** Check if the specified object is an InjectedFactory. */
export function isInjectedFactory(x) {
    return x[INJECTED_FACTORY] === true;
}
//# sourceMappingURL=is-inject-identifier.util.js.map